import React, {memo} from "react";
import {useSelector} from "react-redux";
import ListProductsBody from "./listProducts/ListProductsBody";
import PostScheduleBody from "./postSchedule/PostScheduleBody";
import QuestionsBody from "./questions/QuestionsBody";
import InvoiceBody from "./invoice/InvoiceBody";

const BodyModalShoppingCard = () => {
    const {levelPayment} = useSelector(state => state.modalShoppingCard);

    const handelPagesLevelsShoppingCard = () => {
        switch (levelPayment) {
            case 'LIST_PRODUCTS':
                return <ListProductsBody/>;
            case 'POST_SCHEDULE':
                return <PostScheduleBody/>;
            case 'QUESTIONS':
                return <QuestionsBody/>;
            case 'INVOICE':
                return <InvoiceBody/>;
            default:
                return <div>notFind</div>;
        }
    };

    return (
        <React.Fragment>
            {handelPagesLevelsShoppingCard()}
        </React.Fragment>
    );
};

export default memo(BodyModalShoppingCard);